import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import { Flag } from 'lucide-react';

const AdminHeader = ({ submittedReportsCount }) => {
  const { userProfile } = useAuth();

  const isModerator = userProfile?.role === 'moderator';
  const title = isModerator ? 'Moderation Panel' : 'Admin Dashboard';
  const roleLabel = userProfile?.role?.toUpperCase() || 'USER';

  return (
    <header className="bg-white border-b border-gray-200 px-6 py-3 flex items-center justify-between flex-shrink-0">
      <div>
        <h1 className="text-lg font-semibold text-gray-900">{title}</h1>
        <p className="text-xs text-gray-500">Manage reports, users, and content</p>
      </div>

      <div className="flex items-center gap-3">
        {submittedReportsCount > 0 && (
          <div className="flex items-center gap-1.5 bg-red-50 border border-red-100 text-red-600 text-xs font-semibold px-3 py-1.5 rounded-full">
            <Flag size={12} />
            {submittedReportsCount} pending
          </div>
        )}
        <div className="bg-blue-50 border border-blue-100 text-blue-700 text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wide">
          {roleLabel}
        </div>
        {userProfile?.avatar_url ? (
          <img
            src={userProfile.avatar_url}
            alt={userProfile.full_name}
            className="w-8 h-8 rounded-full object-cover border border-gray-200"
          />
        ) : (
          <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-xs font-semibold text-gray-600">
            {(userProfile?.full_name || 'A').charAt(0).toUpperCase()}
          </div>
        )}
      </div>
    </header>
  );
};

export default AdminHeader;
